import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import Seo from "@/components/Seo";
import { INDUSTRY_PAGES } from "@/data/industries";
import { SEO_DEFAULTS } from "@/data/content";

export default function Industries() {
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "CollectionPage",
    name: "Industries — AlchamisGroup",
    url: `${SEO_DEFAULTS.baseUrl}/industries`,
    hasPart: INDUSTRY_PAGES.map((i) => ({
      "@type": "WebPage",
      name: i.name,
      url: `${SEO_DEFAULTS.baseUrl}/industries/${i.slug}`,
    })),
  };
  return (
    <div data-testid="industries-page" className="pt-32 pb-24">
      <Seo
        title="Industries"
        description="Sectors AlchamisGroup serves — financial services, healthcare, manufacturing, aerospace, technology, hospitality, public sector, and more."
        path="/industries"
        jsonLd={jsonLd}
      />
      <section className="max-w-[1400px] mx-auto px-6 md:px-12">
        <span className="overline">Industries</span>
        <h1 className="font-display text-5xl sm:text-7xl text-[#001B54] mt-6 leading-[1.02]">
          Sectors we know
          <span className="block italic gold-text">as well as our own.</span>
        </h1>
        <p className="text-[#3F4A6B] mt-6 max-w-2xl leading-relaxed">
          Our engagements are led by partners with operating careers inside the industries we serve.
        </p>
      </section>

      <section className="mt-20 max-w-[1400px] mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {INDUSTRY_PAGES.map((i) => (
            <Link
              key={i.slug}
              to={`/industries/${i.slug}`}
              data-testid={`industry-card-${i.slug}`}
              className="group relative overflow-hidden border border-[#001B54]/10 hover:border-gold/40 transition-all duration-500"
            >
              <div className="aspect-[4/3] overflow-hidden">
                <img
                  src={i.hero}
                  alt={i.name}
                  loading="lazy"
                  className="w-full h-full object-cover opacity-60 group-hover:opacity-85 group-hover:scale-105 transition-all duration-1000"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#000B24] via-[#000B24]/70 to-transparent" />
              </div>
              <div className="absolute inset-0 p-6 flex flex-col justify-between">
                <div className="flex justify-between items-start">
                  <div className="text-[0.6rem] tracking-[0.28em] uppercase text-gold">{i.eyebrow}</div>
                  <ArrowUpRight size={16} className="text-gold opacity-0 group-hover:opacity-100 -translate-x-2 group-hover:translate-x-0 transition-all duration-500" />
                </div>
                <div>
                  <h2 className="font-display text-2xl text-[#001B54] leading-tight">{i.name}</h2>
                  <p className="text-[#3F4A6B] text-sm mt-3 leading-snug">{i.lead}</p>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </section>
    </div>
  );
}
